<template>
  <div class="p-6 bg-white rounded-lg">
    <div class="flex items-center mb-4 pb-4 border-b">
      <div
        class="flex-no-shrink w-12 h-12 rounded-lg text-white p-1"
        :class="this.module.settings.icon_color ? this.module.settings.icon_color : 'bg-tertiary'"
      >
        <icon :name="this.module.settings.icon" />
      </div>
      <h3 class="text-2xl font-medium ml-4">
        {{ module.title }}
      </h3>
    </div>
    <p class="text-base leading-tight mb-6" v-html="nl2br(module.settings.description)"></p>
    <loader v-if="pageTurners === null" />
    <div v-else-if="pageTurners.length === 0" class="text-sm">
      <i class="fas fa-info-circle"></i> No page turners for this office
    </div>
    <table class="w-full" v-else>
      <tbody>
        <tr v-for="(pageTurner, i) in pageTurners" :key="i">
          <td class="pb-6 pr-3">
            <strong class="block">{{ pageTurner.name }}</strong>
            <span class="text-sm block mb-1">{{ pageTurner.type }}</span>
            <small class="text-grey-dark">Updated: {{ pageTurner.updated_at | datetime }}</small>
          </td>
          <td class="pb-6 text-right">
            <a :href="pageTurner.url" target="_blank" class="rounded px-3 py-2 whitespace-no-wrap no-underline text-white bg-secondary">
              <i class="fas fa-eye"></i> View
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { nl2br } from '@/helpers'
import { mapState } from 'vuex'
import api from '@/http'

export default {
  props: ['module'],

  data () {
    return {
      pageTurners: null
    }
  },
  computed: {
    ...mapState(['selectedOffice'])
  },
  created () {
    this.getPageTurners()
  },
  methods: {
    nl2br,
    getPageTurners () {
      this.link = null
      api.get('/page-turners', {
        params: {
          office_id: this.selectedOffice.id
        }
      }).then((response) => {
        this.pageTurners = response.data
      })
    }
  },
  watch: {
    selectedOffice: {
      handler () {
        this.getPageTurners()
      },
      deep: true
    }
  }
}
</script>
